var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"banner"}},[_c('picture',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.contents.banner.url,"alt":_vm.contents.banner.altText}})]),_c('h2',[_vm._v(_vm._s(_vm.contents.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }